import { React, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import PopupUpdate from './PopupUpdate';
import axios from 'axios';
import PropagateLoader from 'react-spinners/PropagateLoader';
import { Formik, Form, useField } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import LoadingButton from '@mui/lab/LoadingButton';
import RotateLoader from 'react-spinners/RotateLoader';
import FormHelperText from '@mui/material/FormHelperText';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import AuthContext from '../../auth/auth';
import { socket, SocketContext } from '../../context/socket';

const API_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_ENDPOINT_PROD
    : process.env.REACT_APP_API_ENDPOINT_DEV


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiPaper-root': {
        width: '100%',
        maxWidth: '650px',
    },
}));

function sleep(delay = 0) {
    return new Promise((resolve) => {
      setTimeout(resolve, delay);
    });
  }

function Popup(props) {
    return (
        <>
          <h3 style={{ textAlign: 'center' }}>New Order created!</h3>
          <h1 style={{ textAlign: 'center' }}>Order code is:</h1>
          <p className="code">{props.code}</p>
          <h1 style={{ textAlign: 'center' }}>
            Order will be available in the "Arrived" stage.
          </h1>
          </>
    );
  }

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function NewOrderPopup(props) {
    const [open, setOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [isFilePicked, setIsFilePicked] = useState(false);
    const [isInvalid, setIsInvalid] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [fileGeneratedCode, setFileGeneratedCode] = useState(null);
    const [loading, setloading] = useState(false);
    const user = props.users;


    const changeHandler = (event) => {
        console.log('onchange');
        setSelectedFile(event.target.files[0]);
        setIsFilePicked(true);
      };

    // BACKEND CALL TO RETRIEVE USER INFORMATION

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setShowPopup(false);
        setOpen(false);
    };

    return (
        <div>
           
            <Button size = "small" variant="outlined" onClick={handleClickOpen}> New Order</Button>

            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                    New Order
                    <br></br>
                    {props.users.username}
                </BootstrapDialogTitle>
                <DialogContent>
                {showPopup ? (
        <Popup code={fileGeneratedCode} />
      ) : (
                <Formik
            initialValues={{
              submissionType: '',
              sangerNoOfSamples: '0',
              fragmentNoOfSamples: '0',
            }}
            validationSchema={Yup.object({
              submissionType: Yup.string().required('Required'),
              sangerNoOfSamples: Yup.number()
                .max(96, 'Max amount is 96')
                .min(0, 'Value cannot below 0')
                .required('Required')
                .typeError('Must be a number'),
              fragmentNoOfSamples: Yup.number()
                .max(96, 'Max amount is 96')
                .min(0, 'Value cannot below 0')
                .required('Required')
                .typeError('Must be a number'),
            })}
            enableReinitialize={false}
            onSubmit={async (values) => {
              console.log('onsubmit');
              console.log(values);
              setIsInvalid(false);
              setloading(true);
              await sleep(1e3);
            const formData = new FormData();
            formData.append('clientExcelUploadBody', selectedFile);
            formData.append('submissionType', values.submissionType);
            formData.append('sangerNoOfSamples', values.sangerNoOfSamples);
            formData.append(
                'fragmentNoOfSamples',
                values.fragmentNoOfSamples
            );
            console.log(formData)
            axios({
                method: 'post',
                        url: API_ENDPOINT + (isFilePicked ? ('/order/newAdminOrderWithFile') : ("/order/newAdminOrder")),
                        data: formData,
                        params: {username: user.username,
                            submissionType: values.submissionType,
                            sangerNoOfSamples: values.sangerNoOfSamples,
                            fragmentNoOfSamples: values.fragmentNoOfSamples}
                      })
                        .then((res) => {
                          if (res.status === 200) {
                            setloading(false);
                            setShowPopup(true);
                            setIsInvalid(false);
                            console.log(res)
                            setFileGeneratedCode(res.data.generatedCode);
                          }
                        })
                        .catch(function (error) {
                          setloading(false);
                          setShowPopup(false);
                          setIsInvalid(true);
                          // message if file type is not supported
                          if (error.response.status === 415) {
                            setErrorMessage('Please upload an excel file');
                          } else if (error.response.status === 413) {
                            setErrorMessage(
                              'File is too large! Max Size is 500 KB (0.5 MB)'
                            );
                          } else if (error.response.status === 403) {
                            setErrorMessage(
                              'Max amount of uploaded orders (5 at a time) reached! Please drop off or delete entries before requesting new ones'
                            );
                          } else {
                            setErrorMessage(
                              'Unknown error ocuurred, contact adminsitrator'
                            );
                            console.log(error);
                          }
                        });
                      socket.emit('updateUploadedOrders');
            }}
          >
            {(formikProps) => (
              <Form>
                <label style={{ display: 'block' }}> Submission Type *</label>
                <Box sx={{ minWidth: 120 }}>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <FormControl fullWidth error>
                        <Select
                          value={formikProps.values.submissionType}
                          onChange={(e) => {
                            formikProps.setFieldValue(
                              'submissionType',
                              e.target.value
                            );
                            formikProps.setFieldValue('sangerNoOfSamples', 0);
                            formikProps.setFieldValue('fragmentNoOfSamples', 0);
                          }}
                          placeholder={'Choose a submission type'}
                          error={
                            formikProps.touched.submissionType &&
                            Boolean(formikProps.errors.submissionType)
                          }
                          disabled={loading}
                        >
                          <MenuItem value={'Sanger Sequencing'}>
                            Sanger Sequencing
                          </MenuItem>
                          <MenuItem value={'Fragment Analysis'}>
                            Fragment Analysis
                          </MenuItem>
                          <MenuItem value={'Mixed'}>Mixed</MenuItem>
                        </Select>
                        <FormHelperText>
                          {formikProps.touched.submissionType &&
                            formikProps.errors.submissionType}
                        </FormHelperText>
                      </FormControl>
                    </Grid>

                    {formikProps.values.submissionType ===
                      'Sanger Sequencing' &&
                    formikProps.values.submissionType !== '' ? (
                      <>
                        <Grid item xs={12}>
                          <label style={{ display: 'block' }}>
                            {' '}
                            Reaction Count *
                          </label>
                          <TextField
                            id="sangerNoOfSamples"
                            value={formikProps.values.sangerNoOfSamples}
                            onChange={formikProps.handleChange}
                            error={
                              formikProps.touched.sangerNoOfSamples &&
                              Boolean(formikProps.errors.sangerNoOfSamples)
                            }
                            helperText={
                              formikProps.touched.sangerNoOfSamples &&
                              formikProps.errors.sangerNoOfSamples
                            }
                            disabled={loading}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          {formikProps.values.sangerNoOfSamples !== '' &&
                          formikProps.values.sangerNoOfSamples !== '0' ? (
                            <div>
                              <label style={{ display: 'block' }}>
                                {' '}
                                File Upload (Excel File) (Optional)
                              </label>
                              <input
                                type="file"
                                name="clientExcelUploadBody"
                                onChange={changeHandler}
                                disabled={loading}
                              />
                            </div>
                          ) : null}
                        </Grid>
                      </>
                    ) : null}
                    {formikProps.values.submissionType === 'Mixed' &&
                    formikProps.values.submissionType !== '' ? (
                      <>
                        <Grid item xs={12}>
                          <label style={{ display: 'block' }}>
                            {' '}
                            Reaction Count *
                          </label>
                          <TextField
                            id="sangerNoOfSamples"
                            value={formikProps.values.sangerNoOfSamples}
                            onChange={formikProps.handleChange}
                            error={
                              formikProps.touched.sangerNoOfSamples &&
                              Boolean(formikProps.errors.sangerNoOfSamples)
                            }
                            helperText={
                              formikProps.touched.sangerNoOfSamples &&
                              formikProps.errors.sangerNoOfSamples
                            }
                            disabled={loading}
                          />
                          <label style={{ display: 'block' }}>
                            {' '}
                            Sample Count *
                          </label>
                          <TextField
                            id="fragmentNoOfSamples"
                            value={formikProps.values.fragmentNoOfSamples}
                            onChange={formikProps.handleChange}
                            error={
                              formikProps.touched.fragmentNoOfSamples &&
                              Boolean(formikProps.errors.fragmentNoOfSamples)
                            }
                            helperText={
                              formikProps.touched.fragmentNoOfSamples &&
                              formikProps.errors.fragmentNoOfSamples
                            }
                            disabled={loading}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          {formikProps.values.fragmentNoOfSamples !== '0' &&
                          formikProps.values.sangerNoOfSamples !== '0' &&
                          formikProps.values.fragmentNoOfSamples !== '' &&
                          formikProps.values.sangerNoOfSamples !== '' ? (
                            <div>
                            <input
                                type="file"
                                name="clientExcelUploadBody"
                                onChange={changeHandler}
                                disabled={loading}
                              />
                            </div>
                          ) : null}
                        </Grid>
                      </>
                    ) : null}

                    {formikProps.values.submissionType ===
                      'Fragment Analysis' &&
                    formikProps.values.submissionType !== '' ? (
                      <>
                        <Grid item xs={12}>
                          <label style={{ display: 'block' }}>
                            {' '}
                            Sample Count *
                          </label>
                          <TextField
                            id="fragmentNoOfSamples"
                            value={formikProps.values.fragmentNoOfSamples}
                            onChange={formikProps.handleChange}
                            error={
                              formikProps.touched.fragmentNoOfSamples &&
                              Boolean(formikProps.errors.fragmentNoOfSamples)
                            }
                            helperText={
                              formikProps.touched.fragmentNoOfSamples &&
                              formikProps.errors.fragmentNoOfSamples
                            }
                            disabled={loading}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          {formikProps.values.fragmentNoOfSamples !== '0' &&
                          formikProps.values.fragmentNoOfSamples !== '' ? (
                            <div>
                              <label style={{ display: 'block' }}>
                                {' '}
                                File Upload (Excel File) (Optional)
                              </label>
                              <input
                                type="file"
                                name="clientExcelUploadBody"
                                onChange={changeHandler}
                                disabled={loading}
                              />
                            </div>
                          ) : null}
                        </Grid>
                      </>
                    ) : null}

                    <Grid items xs={12}>
                      <div className="submit-btn">
                        <LoadingButton
                          size="large"
                          type="submit"
                          variant="outlined"
                          loading={loading}
                          loadingIndicator={
                            <RotateLoader size={7} margin={-15} />
                          }
                        >
                          Submit
                        </LoadingButton>
                      </div>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>)}
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose}>
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
